import Dialog from 'core/lib/dialog';

let dialog;
let submitForm = false;
const $body = $('.body');

/**
 * Opens the Blik dialog
 */
const initBlikDialog = () => {
    dialog = new Dialog({
        additionalClasses: ['blik-dialog'],
        isModal: true,
        useLegacyContainer: true,
        canCloseOnBackdropClick: true,
        canClose: true,
        html: $('#blikModal').html(),
        /**
         * callback when dialog is ready
         */
        callback: () => {
            const blikSubmitButton = document.querySelector('#dialog-container .checkout-blik-code-submit');
            blikSubmitButton.addEventListener('click', () => {
                const blikCode = document.querySelector('#dialog-container .js-blick-code-row input');
                if (/^[0-9]{6}$/.test(blikCode.value)) {
                    const submitButton = document.getElementById('dwfrm_summary_save');
                    document.querySelector('#blikCodeSummary').value = blikCode.value;
                    submitForm = true;
                    $(submitButton).trigger('click');
                } else {
                    const blikForm = document.querySelector('#dialog-container .js-blick-code-row');
                    if (!$(blikForm).hasClass('validation-error')) {
                        $(blikForm).addClass('validation-error');
                        $(blikForm).append(`<div class='blik-error-msg'>${Resources.VALIDATE_BLIK_CODE}</div>`);
                    }
                }
            });
            $body.addClass('ui-dialog-prevent-scroll');
        },
        /**
         *
         */
        closeCallback: () => {
            $body.removeClass('ui-dialog-prevent-scroll');
        }
    });

    dialog.open();
};

/**
 *
 * @param {Element} formToSubmit summary form
 */
export default function initializeBlikSummary(formToSubmit) {
    formToSubmit.addEventListener('submit', e => {
        if (!submitForm && formToSubmit.dwfrm_summary_acceptterms.checked) {
            e.preventDefault();
            initBlikDialog(formToSubmit);
        }
    });
}
